import { render, staticRenderFns } from "./topCusIntroduce.vue?vue&type=template&id=1057a8a4&scoped=true&"
import script from "./topCusIntroduce.vue?vue&type=script&lang=js&"
export * from "./topCusIntroduce.vue?vue&type=script&lang=js&"
import style0 from "./topCusIntroduce.vue?vue&type=style&index=0&id=1057a8a4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1057a8a4",
  null
  
)

export default component.exports